/**
 * Return true if two string is equal, case insensitive.
 */

const isStringEqualIgnoreCase = (a, b) => a.toLowerCase() === b.toLowerCase();

export default isStringEqualIgnoreCase;
